import { getUserAccountEvents, listUserSessions, listUserSessionToolCalls, streamUserAiActivity } from '../services/adminApi.js'
import { useEntityActivityLog, type UseEntityActivityLogResult } from './useEntityActivityLog.js'

export type { SessionCallsState } from './useEntityActivityLog.js'

const USER_ACTIVITY_API = {
  getAccountEvents: getUserAccountEvents,
  listSessions: listUserSessions,
  listSessionToolCalls: listUserSessionToolCalls,
  streamActivity: streamUserAiActivity,
}

export function useUserActivityLog(userId: string | null): UseEntityActivityLogResult {
  return useEntityActivityLog(userId, USER_ACTIVITY_API)
}
